import { api } from "./client.js";

export interface CountryDays {
  country_code: string;
  country: string;
  days: number;
}
export interface ResidencyFlag extends CountryDays {
  threshold: number;
  status: "over" | "approaching";
}

export const taxApi = {
  days: (year: number) =>
    api.get<{ year: number; days: CountryDays[] }>(`/api/tax/days?year=${year}`),
  residency: (year: number) =>
    api.get<{ year: number; flags: ResidencyFlag[]; disclaimer: string }>(
      `/api/tax/residency?year=${year}`,
    ),
};
